import React from 'react';

function LipidProfileForm() {
  return (
    <div>
      <h2>LipidProfileForm</h2>
    </div>
  );
}

export default LipidProfileForm;
